// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, object, string } from 'prop-types'
import Dropzone from 'react-dropzone'
import ErrorSimple from './ErrorSimple'

// NOTE - if multiple is to false, the field's value should
// still be an array. The Dropzone component expects that
// its value is always an array and gets real fussy
// when you try to give it a Blob directly.

class DropZoneField extends React.Component {
  static propTypes = {
    className: string,
    id: string.isRequired,
    input: object.isRequired,
    label: string,
    meta: object.isRequired,
    multiple: bool,
    onChangeCustom: func,
  }

  static defaultProps = {
    className: '',
    label: 'Attachments',
    multiple: true,
  }

  addFiles = (newFiles, rejectedFiles) => {
    const {
      input,
      multiple = true,
      onChangeCustom,
    } = this.props

    if (onChangeCustom) {
      return onChangeCustom({ newFiles, rejectedFiles }, input.onChange)
    }

    if (multiple) {
      const currentFiles = input.value || []
      input.onChange([...currentFiles, ...newFiles])
    } else {
      // newFiles here will always be an array with length of 1
      input.onChange(newFiles)
    }
  }

  removeFile = index => {
    const { input } = this.props
    const f = [...input.value]
    f.splice(index, 1)
    input.onChange(f)
  }

  render () {
    const {
      className,
      id,
      input,
      label,
      meta,
      multiple,
    } = this.props

    const files = input.value || []

    return (
      <div className={`drop-zone ${className}`}>
        <dl className={'drop-zone-list'}>
          <dt>
            <strong className={'uppercase'}>
              {label}
            </strong>
            <span>
              {'File Name'}
            </span>
          </dt>
          {files.map((file, i) => (
            <dd key={`${i}-${file.name}`}>
              <span
                className={'pull-right pointer'}
                onClick={e => { this.removeFile(i) }}>
                {'X'}
              </span>
              {file.name}
            </dd>
          ))}
        </dl>
        <Dropzone
          id={id}
          multiple={multiple}
          name={name}
          onDrop={this.addFiles}>
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps()}
              className={'drop-zone-component center-text'}>
              <p>
                <span className={'padding-right-half'}>
                  {'Drop File Here'}
                </span>
                <i className={'fa fa-file-text-o'} />
              </p>
              <p
                id={`${id}-upload-file-button`}
                className={'upload-decoration uppercase'}>
                {'Upload File'}
              </p>
              <input {...getInputProps()} />
            </div>
          )}
        </Dropzone>
        <ErrorSimple
          error={meta.error}
          idRoot={id} />
      </div>
    )
  }
}

export default DropZoneField
